const STATUS_CLASS: Record<string, string> = {
  Active: 'status-active',
  Pending: 'status-pending',
  Suspended: 'status-suspended',
};

export function StatusPill({ status }: { status: string }) {
  return (
    <span className={`status-pill ${STATUS_CLASS[status] ?? 'status-pending'}`}>
      <span className="status-dot" />
      {status}
    </span>
  );
}
